module.exports = __webpack_public_path__ + "media/images/templatePc-5298ec477caaf83e36deb1b4bb90e7d6.svg";